import { gql } from "urql";
export const GetPriorityEmailRecordsQuery = gql `
    query GetPriorityEmailRecords(
        $search: String
        $offset: Int
        $type: PriorityEmailType
    ) {
        priorityEmailRecords {
            priorityEmailRecords(
                search: $search
                offset: $offset
                type: $type
            ) {
                priorityEmailRecordId
                priorityEmailAction
                email
                priorityEntry {
                    patient {
                        patientId
                        firstName
                        lastName
                        dateOfBirth
                        postalCodeInfo {
                            city
                            stateId
                            postalCode
                        }
                    }
                    therapyCategory {
                        therapyCategoryId
                        name
                    }
                    caregiver {
                        userId
                        firstName
                        lastName
                        email
                        phoneNumber
                    }
                }
                invitingUser {
                    userId
                    name
                    email
                    imageUrl
                }
                updatedAt
            }
        }
    }
`;
export const GetPriorityEmailRecordCountQuery = gql `
    query GetPriorityEmailRecordCount(
        $search: String
        $type: PriorityEmailType
    ) {
        priorityEmailRecords {
            priorityEmailRecordCount(search: $search, type: $type)
        }
    }
`;
